function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.727 45.731c3.28 4.032 6.444 8.708 9.088 9.274H53.58c.928 0 1.855-.556 1.855-2.034 0-1.28-1.038-1.768-2.318-1.768-4.497.188-9.44-.01-13.447 0-4.637 0-1.855-30.51-19.475-29.583-3.178.167-2.274-8.069-4.637-10.201-1.092-.986-2.477-1.405-3.912-1.391-.86.01-1.745.175-2.58.464-3.66 1.267-7.744 7-5.563 10.2 2.782.928 7.419-.927 7.419-.927-.446 4.804-.045 7.759.874 10.191m1.408 3.013c2.148 2.901 5.344 3.883 8.104 5.344"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.067 10.492s-2.782-6.464.927-8.319C13 4 11.85 9.564 11.85 9.564S14 3 18.94 3.1c-.94 5.9-5.607 7.206-5.607 7.206M25.76 29.039c-10.547.93-1.935 14.215-.754 21.33-5.738 0-6.666 0-15.997.086-1.025.24-1.797 1.134-1.797 2.232 0 1.11.784 2.091 1.826 2.318 6.703.15 13.656 0 20.43 0 .928-3.71-2.112-10.492 0-13.91.728-1.176 3.71-1.855 3.71-1.855"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.463 36.3c1.075 4.15 3.278 8.865 3.833 12.214-5.738 0-6.665 0-15.997.087-1.024.24-1.796 1.133-1.796 2.231 0 1.11.783 2.091 1.826 2.318.671.015 1.345.027 2.022.036"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.977 14.637a1.391.464-20.672 11-2.603.982 1.391.464-20.672 112.603-.982z",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.34 24.402s-.772 3.936-1.854 5.564c-1.82 2.737-5.706 3.688-7.42 6.492-.664 1.088.347 3.66-.927 3.71-1.953.074-2.376-3.68-1.854-5.565.76-2.746 4.993-3.14 6.491-5.564.67-1.084.928-3.71.928-3.71"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.643 26.257s-2.265 2.367-3.431 2.967c-1.672.86-3.072.998-4.637 2.04-2.782 1.855-2.423 5.389-.927 4.266 3.71-2.782 5.842-2.782 5.842-2.782"
}));

var SvgKangaroo = function SvgKangaroo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKangaroo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Kangaroo.9f3d9568.svg";
export { ForwardRef as ReactComponent };